// Maps domain values to Badge `status` tones. Separate from statusStyles.js,
// which returns raw class strings and is still consumed by the modals until
// Plan 2c converts them.
export const STATUS_TONE = {
  created: 'info',
  diagnosing: 'warning',
  diagnosed: 'success',
  estimating: 'info',
  quoted: 'info',
  approved: 'success',
  in_progress: 'warning',
  completed: 'neutral',
  cancelled: 'danger',
  on_hold: 'warning',
};

export const PRIORITY_TONE = { low: 'success', normal: 'info', high: 'warning', urgent: 'danger' };

export const COMPLEXITY_TONE = { simple: 'success', moderate: 'warning', complex: 'danger' };
